import { render, staticRenderFns } from "./OverlayBody.vue?vue&type=template&id=1092634a&scoped=true"
import script from "./OverlayBody.vue?vue&type=script&lang=js"
export * from "./OverlayBody.vue?vue&type=script&lang=js"
import style0 from "./OverlayBody.vue?vue&type=style&index=0&id=1092634a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1092634a",
  null
  
)

export default component.exports